import React , {useEffect} from "react";
import { useNavigate } from "react-router-dom";

import factory from '../../Assets/factory.mp4'
import News from "../../Pages/Home/Components/News/News";
import Footer from '../../Components/Footer/Footer'
import Navbar from '../../Components/NavBar/NavBar'
import pic from '../../Assets/mount.jpg'

import "./About.scss";





const About = () => {
  let Navigate = useNavigate()

  useEffect(() => {
    window.scrollTo(0, 0);

}, [])

  return (
    <>
      <div className="about_main">

        <div className="about_home">
          <div className="title">Flux Technologies Africa</div>
        </div>

        <div className="spirit" style={{ backgroundColor: "#F7F497" }}>
          <div className="spirit_para">
            The spirit of California moves us to think beyond mobility, and design
            for a world where life is the most important journey we’ll ever take;
            to look beyond tomorrow and shape a future where we no longer have to
            choose between doing great things and doing the right thing; and to
            explore beyond ourselves, and create experiences that remind us what
            it’s like to feel truly alive.
          </div>
        </div>

        <div className="sustain">
          <div className="back"></div>
          <div className="text_main">
            <div className="text_content">
              <h2>Sustainability</h2>
              <p>
                We aim to create sustainable mobility without compromise in cars
                that are intuitive, liberating, and designed for all the ways
                people get around. At Flux, we place an exceptionally high
                priority on efficiency — our cars must make the best possible use
                of the world’s resources. So, every Flux delivers exceptional
                range without sacrificing high performance or sublime comfort.
              </p>
              {/* <button className="btb" onClick={()=> Navigate("about")}>About Us</button> */}
            </div>
          </div>
        </div>
        <div className="sustain">
          <div className="back_2"></div>
          <div className="text_main">
            <div className="text_content">
              <h2>Leadership</h2>
              <p>
                Flux’s leadership team brings to our Silicon Valley headquarters
                an extraordinary depth of knowledge and experience from the
                automotive and technology industries. They’re leading us forward
                to a more sustainable future as we use proprietary electric
                vehicle technology to reinvent the category for each type of car
                we build.
              </p>
              {/* <button className="btb" onClick={()=> Navigate("contact")}>Contact</button> */}
            </div>
          </div>
        </div>
        {/* <div className="sustain">
        <div className="back_3"></div>
        <div className="text_main">
          <div className="text_content">
            <h2>Careers</h2>
            <p>
              Come work alongside some of the most accomplished minds in the
              automotive and technology industries. Beyond competitive salaries,
              we are creating a community for innovators who want to make a
              significant — and immediate — contribution to the future of
              sustainable mobility.
            </p>
            <button className="btb">Discover</button>
          </div>
        </div>
      </div> */}

        <div className="spirit">
          <div className="title">Flux Motors Factory</div>
          <div className="spirit_para">
            After evaluating over 60 sites in 13 states for the Flux Motors
            factory, we chose a 500-acre property in Casa Grande, Arizona. Located
            between Phoenix and Tucson — and within easy reach of our Silicon
            Valley headquarters — the Casa Grande offered close proximity to
            critical utilities, an established transportation system, and strong
            support from state and local governments.
          </div>

          <div className="para">
            This facility is the first greenfield — or purpose-built — EV factory
            in North America. Designed to our exact specifications, it is being
            built with such efficiency and speed that we will complete
            construction of its first phase a mere 12 months after breaking
            ground. Outfitted with the world’s most advanced production line
            equipment, the factory will have the initial capacity to produce
            10,000 cars a year — and over 300,000 annually with planned expansion.
          </div>
        </div>


        {/* <div className="video">
        <video src={factory} loop autoPlay playsInline muted ></video>
      </div> */}
      </div>
      <News />
    </>
  );
};

export default About;
